export function DateBadge({ date }: { date: string | null }) {
  if (!date) {
    return (
      <div className="flex w-11 shrink-0 flex-col items-center justify-center text-slate-400">
        <span className="text-[9px] font-medium uppercase">Termin</span>
        <span className="text-xs">offen</span>
      </div>
    );
  }
  const d = new Date(`${date}T00:00:00`);
  return (
    <div className="flex w-11 shrink-0 flex-col items-center justify-center text-slate-600">
      <span className="text-[9px] font-semibold uppercase text-slate-400">
        {d.toLocaleDateString('de-DE', { weekday: 'short' })}
      </span>
      <span className="text-lg font-bold leading-tight">{d.getDate()}</span>
      <span className="text-[9px] text-slate-400">{d.toLocaleDateString('de-DE', { month: 'short' })}</span>
    </div>
  );
}
